<template>
	<div class="container">
		<a
			v-bind:href="app"
			class="logo"
		>
			<img src="/static/images/logo.png" alt="Logo">
		</a>

		<h1>
			{{ $t(`titles.${$route.name}`).split('-')[0] }}
		</h1>

		<div class="card-box">
			<router-view></router-view>
		</div>
	</div>

	<BottomNavigation></BottomNavigation>

	<AppTitle
		:key="$route.name"
		v-if="$route.name"
	>
		{{ $t(`titles.${$route.name}`) }}
	</AppTitle>
</template>

<script setup>
	import { computed } from 'vue'
	import BottomNavigation from './../parts/BottomNavigation'
	import AppTitle from '../components/AppTitle'

	let app = computed(() => process.env.MIX_APP_BASE_URL)
</script>
